/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Seo1Inputs */

const vi_cmspost_seo1 = /** @type {(inputs: Cmspost_Seo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO`)
};

/**

* @param {Cmspost_Seo1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_seo1 = /** @type {((inputs?: Cmspost_Seo1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Seo1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_seo1(inputs)
});
export { cmspost_seo1 as "cmsPost_seo" }